<template>
    <v-menu 
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="20"
        :nudge-bottom="10"
        transition="scale-transition"
        min-width="290px"
        max-width="580px"
        :disabled="readonly"
    >
        <template v-slot:activator="{on}">
            <v-text-field v-model="value" prepend-icon="event" v-on="on" :label="label" :rules="rules" :readonly="readonly" :clearable="!readonly" @click:clear="$emit('input', null)" /> 
        </template>
        <v-card>
                <v-date-picker v-model="date" locale="id"></v-date-picker>
                <v-time-picker v-model="time" format="24hr"></v-time-picker>
            <v-card-actions>
                <v-btn text color="primary" @click="cancelDateTime()">Cancel</v-btn>
                <v-btn text color="primary" @click="saveDateTime()">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>    
</template>

<script>

export default {
    model: {
        prop: "datetime",
        event: "input"
    },


    props: {
        datetime: {
            type: [ Date, String ],
            default: null
        },

        label: {
            type: String,
            default: ""
        },

        readonly: {
            type: Boolean,
            default: false
        },

        rules: {
            type: Array,
            required: false
        }
    },


    data() {
        return {
            menu: false,
            date: new Date().toISOString().substr(0, 10),
            time: "00:00",
            value: "",
        }
    },


    mounted() {
        this.resetDateTime();        
    },


    methods: {
        resetDateTime() {
            if (this.datetime == null || this.datetime == "")
            {
                this.date = new Date().toISOString().substr(0, 10);
                this.time = "00:00";
                this.value = "";
            }
            else
            {
                const dateTimeString = (this.datetime instanceof Date) ? this.datetime.toISOString() : new Date(this.datetime).toISOString();
                this.date = dateTimeString.substr(0, 10);
                this.time = dateTimeString.substr(11, 5);
                this.value = `${this.date} ${this.time}:00`;
            }
        },

        cancelDateTime() {
            this.resetDateTime();            
            this.menu = false;
        },


        saveDateTime() {
            console.log("Selected Date: ", this.date);
            console.log("Selected Time: ", this.time);

            this.value = `${this.date} ${this.time}:00`;
            let newDateTime = new Date(this.date);
            console.log("DATE: ", newDateTime);
            const hours = Number(this.time.substr(0, 2));
            const minutes = Number(this.time.substr(3, 2));
            console.log("TIME: ", this.time);
            console.log("HOURS: ", hours);
            console.log("MINUTES: ", minutes);
            newDateTime.setUTCHours(hours, minutes, 0);
            console.log("SAVED DateTime: ", newDateTime);

            this.$emit("input", newDateTime);
            this.menu = false;
        }
    }
}

</script>
